import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/mail-exchange.svg';
const MailExchange = () => React.createElement(IconSvg, null);
export default MailExchange;
